import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNoteText: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="note-text"><path d="M3.75 3.75H20.25V16L16 20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 8.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 12.75H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20 15.25H15.25V20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNoteText;
